import { createBrowserClient } from '@supabase/ssr';
import { authCookieOptions } from './lib/authCookie';

// Both values are baked into the bundle by CRA at build time and are meant to be
// public: the anon key only ever grants what row-level security allows. Never put
// a service_role key here — it bypasses RLS entirely and would hand every visitor
// full read/write on the database.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. ' +
      'Copy .env.example to .env.local for local development; on the server set them in .env ' +
      'so docker compose can pass them as build args.'
  );
}

// createBrowserClient (не createClient): сессия ложится в куку родительского
// домена, и «Интеллект» на соседнем поддомене её видит — см. lib/authCookie.js.
//
// Единственный клиент на всё приложение. Раньше их было два (этот и
// lib/supabaseClient.js): два экземпляра GoTrue в одной вкладке конкурируют за
// обновление токена, а второй к тому же не знал про общую куку — все запросы
// к словарю уходили анонимными.
export const supabase = createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  db: { schema: 'speech_assessment' },
  cookieOptions: authCookieOptions(window.location),
});

// Словарь и озвучка живут в отдельной схеме. Схема задаётся на запрос, а не
// вторым клиентом.
export const newLandingSchema = () => supabase.schema('new_landing');
